import {Component, OnInit} from '@angular/core';
import {ImageUrls} from '../../../shared/constants/ImageUrls';
import {RouteUrls} from '../../../shared/constants/RouteUrls';

@Component({
  selector: 'app-header-not-logged',
  templateUrl: './header-not-logged.component.html',
  styleUrls: ['./header-not-logged.component.scss']
})
export class HeaderNotLoggedComponent implements OnInit {
  logo = ImageUrls.LOGO_WHITE;
  loginUrl = RouteUrls.AUTHENTICATION.LOGIN;
  accreditationApplication = RouteUrls.APPLICATION.MODULE_BASE;

  constructor() {
  }

  ngOnInit() {
  }

}
